import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MenuComponent } from './menu/menu.component';

//const routes = RouterModule.forChild([
//  { path: '', component: MenuComponent }
//])

@NgModule({
  declarations: [
    MenuComponent
  ],
  exports: [
    MenuComponent
  ],
  imports: [
    CommonModule, MatToolbarModule, MatIconModule
    //AppRoutingModule
    //routes
  ]
})
export class MenuModule { }
